<template>
  <div class="details-view">
    <div class="main-contain">
      <el-form class="section" label-position="right" label-width="70px" label-suffix=":">
        <div class="app-main-inner-row" style="flex-direction: column">
          <el-divider content-position="left">{{ $t('SystemDocking.ImportSettings') }}</el-divider>
          <el-form-item :label="$t('SystemDocking.BusinessType')">
            <el-radio-group v-model="form.type">
              <el-radio label="SI">{{ $t('SystemDocking.OceanImport') }}</el-radio>
              <el-radio label="AI">{{ $t('SystemDocking.AirCargoImport') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="flex-direction: column">
          <el-divider content-position="left">{{ $t('SystemDocking.ImportFile') }}</el-divider>
          <el-col :span="8">

            <el-form-item :label="$t('SystemDocking.File')">
              <div style="display: flex;justify-content: flex-start">
                <el-upload
                  ref="uploader"
                  :accept="accept.join(',')"
                  :action="`${URL.systemDocking.kef.importBill}?lob=${form.type}&fileFlagNo=${fileFlagNo}`"
                  :auto-upload="false"
                  :headers="{
                    sessionId:$store.getters.token
                  }"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="onSuccess"
                >
                  <el-button slot="trigger" size="small" type="primary">{{ $t('SystemDocking.SelectFile') }}</el-button>
                  <el-link type="primary" style="margin-left: 5px" :href="importTemplate" :download="importTemplateName">{{ $t('SystemDocking.DownloadTemplate') }}</el-link>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <div style="display: flex;justify-content: space-between">
                <span class="orange">{{ $t('SystemDocking.ReminderCannotExceed100Lines') }}</span><el-button type="primary" @click="submit">{{ $t('SystemDocking.ConfirmImport') }}</el-button>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { AI } from '@/class/cargo/model/parameters/SystemConstants'
import { v4 as uuidv4 } from 'uuid'
import { getFileId } from '@/api/systemDocking/kef.js'
import { cache, cacheName } from '@/utils/cacheManager'
export default {
  name: 'TabBatchImportOrder',
  data() {
    return {
      URL,
      form: {
        type: 'SI'
      },
      fileFlagNo: '',
      accept: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    }
  },
  computed: {
    importTemplate() {
      const { type } = this.form
      return `/static/file/kef/${type === 'AI' ? '空运进口导入模板' : '空运进口导入模板'}.xlsx`
    },
    importTemplateName() {
      const { type } = this.form
      return `${type === 'AI' ? 'ImportAITemplate' : 'ImportSITemplate'}`
    }
  },
  mounted() {
    this.setFileFlagNo()
  },
  methods: {
    submit() {
      this.$refs.uploader.submit()
    },
    onError(err) {
      this.$message.error(JSON.parse(err.message).message)
    },
    beforeUpload(file) {
      console.log(file)
      const isExcel = this.accept.indexOf(file.type) !== -1
      if (!isExcel) {
        this.$message.error(this.$t('SystemDocking.UploadedInXLSOrFormat'))
      }
      return isExcel
    },
    onSuccess(res) {
      const { type } = this.form
      let message = ''
      if (type === 'AI') {
        console.log('ai')
        const { jobFailCount, jobImportCount } = res.data
        const h = this.$createElement
        const node = []
        node.push(h('div', { style: 'text-align:left;' }, this.$t('Pricing.XSuccessfulXFailed', [jobImportCount, jobFailCount])))
        node.push(h('div', { style: 'margin:5px 0;text-align:right', attrs: {
          class: 'blue'
        }}, [
          h('a', { on: { click: this.downloadResult }}, this.$t('SystemDocking.DownloadImportResult'))
        ]))
        message = h('div', null, node)
      } else {
        const { jobFailCount, jobImportCount, itemFailCount, itemImportCount, containerFailCount, containerImportCount } = res.data
        const h = this.$createElement
        const node = []
        node.push(h('div', { style: 'display:flex; justify-content:space-between' }, [
          h('span', null, 'Job Info'),
          h('span', null, this.$t('Pricing.XSuccessfulXFailed', [jobImportCount, jobFailCount]))
        ]))
        node.push(h('div', { style: 'display:flex; justify-content:space-between' }, [
          h('span', null, 'Item Info'),
          h('span', null, this.$t('Pricing.XSuccessfulXFailed', [itemImportCount, itemFailCount]))
        ]))
        node.push(h('div', { style: 'display:flex; justify-content:space-between' }, [
          h('span', null, 'Container Info'),
          h('span', null, this.$t('Pricing.XSuccessfulXFailed', [containerImportCount, containerFailCount]))
        ]))
        node.push(h('div', { style: 'margin:5px 0;text-align:right', attrs: {
          class: 'blue'
        }}, [
          h('a', { on: { click: this.downloadResult }}, this.$t('SystemDocking.DownloadImportResult'))
        ]))
        message = h('div', null, node)
      }
      this.$confirm(message, this.$t('SystemDocking.DownloadComplete'), {
        cancelButtonText: this.$t('SystemDocking.Return'),
        confirmButtonText: type === 'AI' ? this.$t('SystemDocking.EnterAirCargoImport') : this.$t('SystemDocking.EnterSeaCargoImport'),
        closeOnClickModal: false,
        showConfirmButton: type === 'SE',
        type: 'success'
      }).then(() => {
        this.$router.push({ name: type === AI ? 'AiBooking' : 'SiBooking' })
      }).finally(() => {
        this.setFileFlagNo()
      })
    },
    setFileFlagNo() {
      this.fileFlagNo = uuidv4().replace(/\-/g, '')
    },
    async downloadResult() {
      const { fileFlagNo } = this
      const res = await getFileId(fileFlagNo)
      if (res.data) {
        await cache.load(cacheName.USER, cacheName.CONFIG)
        const storageUrl = cache.config.get('StorageURL')
        const url = `${URL.common.findByFileId}/${res.data}?sessionId=${this.$store.getters.token}`
        const el = document.createElement('a')
        document.body.appendChild(el)
        el.href = url
        el.target = '_blank'
        el.click()
        document.body.removeChild(el)
      }
    }
  }
}
</script>

<style scoped>

</style>
